module.exports = "/fonts/NeoSansStd-Regular.ttf?779ed18a2b0f629a89cfa1114926aa18";